import anime from 'animejs';
import { last } from 'lodash';
import Component from 'navigation/component/Component';
import detect from 'helpers/detect';
import resize, { dimensions } from 'helpers/resize';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import Carousel from 'components/carousel/Carousel';
class ProductZoom extends Component {
    mouseState;
    savedOrder;
    thumbFollowHeight;
    small = false;
    constructor(el, options) {
        super(el, options);
        this.mouseState = null;
        this.thumbFollowHeight = 0;
    }
    initialized() {
        super.initialized();
        this.small = this.el.classList.contains('small');
    }
    getModulesMap() {
        return {
            carousel: ['.product-zoom__inner', Carousel]
        };
    }
    bindModules() {
        super.bindModules();
        this.savedOrder = this.modules.carousel.items.slice(0);
    }
    open(id = 0) {
        this.resetState(true);
        this.savedOrder = this.modules.carousel.items.slice(0);
        this.savedOrder.forEach(item => {
            this.modules.carousel.el.appendChild(item);
        });
        this.modules.carousel.items = Array.from(this.modules.carousel.el.children);
        this.refs.imageZoom.forEach(i => {
            i.src = i.getAttribute('data-src');
        });
        this.el.classList.add('visible');
        // scroll to the selected item
        const current = this.refs.itemsZoom[id];
        if (current)
            this.refs.listZoom.scrollTop = this.small ? current.offsetTop + current.offsetHeight / 2 - dimensions().innerHeight / 2 : current.offsetTop;
        this.onScroll();
        setTimeout(() => {
            this.resize();
        }, 100);
    }
    onClose = () => {
        this.el.classList.remove('visible');
    };
    bindEvents(add = true) {
        super.bindEvents();
        const method = bindEmitterMethod(add);
        const methodNative = bindMethod(add);
        this.modules.carousel[method]('update', this.onUpdate);
        this.refs.listZoom[methodNative]('scroll', this.onScroll);
        this.refs.closeZoom[methodNative]('click', this.onClose);
        this.refs.zoomThumbItems[methodNative]('click', this.onThumbClick);
    }
    onThumbClick = (event) => {
        const mouseEvent = event; // Cast event to MouseEvent
        const thumbClickPosition = mouseEvent.clientY - (this.refs.zoomThumbItems.getBoundingClientRect().top);
        const thumbClickRatio = thumbClickPosition / this.refs.zoomThumbItems.scrollHeight;
        const scrollTarget = thumbClickRatio * this.refs.listZoom.scrollHeight - dimensions().innerHeight / 2;
        this.refs.listZoom.scrollTo({
            top: scrollTarget,
            behavior: 'smooth'
        });
    };
    onScroll = () => {
        const scrollableHeight = this.refs.listZoom.scrollHeight;
        const scrollY = this.refs.listZoom.scrollTop;
        const thumbTop = (scrollY / scrollableHeight) * 100;
        const thumbFollowHeightPercentage = (this.thumbFollowHeight / this.refs.zoomThumbItems.scrollHeight) * 100;
        const adjustedThumbTop = Math.min(thumbTop, 100 - thumbFollowHeightPercentage);
        this.refs.trackZoom.style.setProperty('--zoom-thumb-top', `${adjustedThumbTop}%`);
    };
    updateState(state) {
        if (detect.touch || state === this.mouseState)
            return;
        this.el.classList.remove(this.mouseState);
        this.el.classList.add(state);
        this.mouseState = state;
        if (state !== 'close')
            this.bait(state);
        else
            this.animateOffset(0);
    }
    resetState(direct = false) {
        if (direct)
            this.modules.carousel.shift = 0;
        else
            this.animateOffset(0);
        this.el.classList.remove(this.mouseState);
        this.mouseState = null;
    }
    bait(state) {
        const offset = (state === 'prev' ? 1 : -1) * resize.width() * .15;
        this.animateOffset(offset);
    }
    animateOffset(shift) {
        const { carousel } = this.modules;
        if (carousel.shift === shift)
            return;
        anime.remove(carousel);
        return anime({
            targets: carousel,
            shift,
            easing: 'easeOutCubic',
            duration: 400,
            complete: () => carousel.updatePosition(true),
            change: () => carousel.updatePosition(true)
        });
    }
    onRearrangeCarousel = (step) => {
        const { carousel } = this.modules;
        const lastIndex = carousel.items.length - 1;
        if (step <= 0) {
            const firstItem = carousel.items[0];
            const lastItem = last(carousel.items);
            carousel.el.insertBefore(lastItem, firstItem);
            carousel.items = Array.from(carousel.el.children);
            carousel.resize();
            this.modules.carousel.goTo(1, true);
        }
        else if (step >= lastIndex) {
            const firstItem = carousel.items[0];
            carousel.el.appendChild(firstItem);
            carousel.items = Array.from(carousel.el.children);
            carousel.resize();
            this.modules.carousel.goTo(lastIndex - 1, true);
        }
    };
    onUpdate = (step) => {
        // this.onRearrangeCarousel(step)
    };
    resize() {
        super.resize();
        const wrapperHeight = this.refs.listZoom.scrollHeight - 25;
        const vh = window.innerHeight;
        const wrapperThumbHeight = this.refs.zoomThumbItems.scrollHeight;
        this.thumbFollowHeight = (wrapperThumbHeight * vh) / wrapperHeight;
        this.refs.trackZoom.style.setProperty('--zoom-thumb-height', `${this.thumbFollowHeight}px`);
    }
}
export default ProductZoom;
